import axios from "axios";
import Vue from "vue";
import configuration from "@/utils/configuration";
import { handleError } from "@/utils/errorHandler";

export default {
  namespaced: true,
  state: {
    userClass: [],
    StudyInformation: {},
    StudyDetailMore: {},
    coursesBooked: {},
    CoursesBookedDetail: {},
    Events: [],
    EventsINDay: [],

    loading: {},
    error: {},
  },
  mutations: {
    SET_USER_CLASS(state, data) {
      state.userClass = data;
    },
    SET_STUDY_INFO(state, data) {
      state.StudyInformation = data;
    },
    SET_DETAIL_MORE(state, data) {
      state.StudyDetailMore = data;
    },
    SET_COURSES_BOOKED(state, data) {
      state.coursesBooked = data;
    },
    SET_COURSES_BOOKED_Detail(state, data) {
      state.CoursesBookedDetail = data;
    },
    SET_EVENTS(state, data) {
      state.Events = data;
    },
    SET_EVENTS_TODAY(state, data) {
      state.EventsINDay = data;
    },

    SET_LOADING(state, { action, status }) {
      Vue.set(state.loading, action, status);
    },
    SET_ERROR(state, { action, message }) {
      Vue.set(state.error, action, message);
    },
  },
  actions: {
    async myCourses({ commit },params) {
      const action = "myCourses";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const student_id = JSON.parse(localStorage.getItem("user")).userId;
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/student?student_id=${student_id}`,
          params:params,
          withCredentials: true,
        });
        commit("SET_USER_CLASS", response.data.data);
        return response.data
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async StudyInfo({ commit }, productSeatId) {
      const action = "StudyInfo";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/user/checkin`,
          params: { product_seat_id: productSeatId },
          withCredentials: true,
        });
        commit("SET_STUDY_INFO", response.data.data);
        return response.data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
async parentStudyInfo({ commit },params) {
      const action = "parentStudyInfo";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/parent/child-checkin`,
          params:params,
          withCredentials: true,
        });
        commit("SET_STUDY_INFO", response.data.data);
        return response.data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async StudyDetailMore({ commit }, payload) {
      const action = "StudyDetailMore";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      const { date, courseId, startTime, endTime, userId } = payload;
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/schedule/assessment/search`,

          params: {
            date,
            course_id: courseId,
            start_time: startTime,
            end_time: endTime,
            user_id: userId,
          },
          withCredentials: true,
        });
        commit("SET_DETAIL_MORE", response.data.data);
        return response.data.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async coursesBooked({ commit }) {
      const action = "coursesBooked";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/user/reserve`,

          withCredentials: true,
        });
        commit("SET_COURSES_BOOKED", response.data.data);
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async CoursesBookedDetail({ commit }, courseId) {
      const action = "CoursesBookedDetail";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/user/reserve/details?course_id=${courseId}`,

          withCredentials: true,
        });
        commit("SET_COURSES_BOOKED_Detail", response.data.data);
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async LearnnerSchedules({ commit }, params) {
      const action = "LearnnerSchedules";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/schedules/student/calendar`,

          params,
          withCredentials: true,
        });
        commit("SET_EVENTS", response.data.data);
        return response.data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async LearnnerScheduleById({ commit }, { userId, option }) {
      const action = "LearnnerScheduleById";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/schedules/user/calendar`,

          params: {
            user_id: userId,
            view: option,
          },
          withCredentials: true,
        });
        commit("SET_EVENTS", response.data.data);
        return response.data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async EventsToday({ commit }) {
      const action = "EventsToday";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/schedules/student/calendar?view=DAILY`,

          withCredentials: true,
        });
        commit("SET_EVENTS_TODAY", response.data.data);
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    //------------ For Parent -----------------
    async getParentCourse({ commit }, params) {
      const action = "getParentCourse";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/parent/child-course`,
          params: params,
          withCredentials: true,
        });
        return response.data;
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getChildSchedules({ commit }, params) {
      const action = "getChildSchedules";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/schedules/user/calendar`,
          params,
          withCredentials: true,
        });
        commit("SET_EVENTS", response.data.data);
        return response.data.data;
      } catch (error) {
        handleError(commit, action, error);
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async childCoursesBooked({ commit },studentId=null) {
      const action = "childCoursesBooked";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, message: null });
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/parent/reserve`,
          params:{ student_id:studentId },
          withCredentials: true,
        });
        commit("SET_COURSES_BOOKED", response.data.data);
      } catch (error) {
        handleError(commit, action, error);
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
  },
  getters: {
    getUserClass: (state) => state.userClass,
    getStudyInformation: (state) => state.StudyInformation,
    getStudyDetailMore: (state) => state.StudyDetailMore,
    getCoursesBooked: (state) => state.coursesBooked,
    getCoursesBookedDetail: (state) => state.CoursesBookedDetail,
    getEvents: (state) => state.Events,
    getEventsToday: (state) => state.EventsINDay,
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },
};
